import { CosntraintsEditorFacet } from '@/common/ConstraintsEditor';
import Service from '@/lib/App';
import { VariableInfo } from '@/lib/PlannerDTOs';

export function getVariableFacets(
  variable: VariableInfo,
): CosntraintsEditorFacet[] {
  const facets = Service.cache.getAllFacets();
  const variableFacets = variable?.facets;

  if (!variableFacets?.length) return [];

  return facets
    .filter((facet) => variableFacets.includes(facet.name))
    .map((facet) => {
      return { value: facet.name, label: facet.title };
    });
}
